const INFO = {
	main: {
		title: "printer repair solution",
		name: "printer repair.",
		email: "",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/",
		linkedin: "https://linkedin.com/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Konica Minolta Printer Repair.",
		description:
			"Is your Konica Minolta printer giving you trouble? Don't let paper jams, poor print quality, error codes, or connectivity issues slow you down! Our certified technicians provide fast, on-site & remote repairs, using genuine parts to restore performance.",
	},

	about: {
		title: "ABOUT US",
		description:
			"At Konica Minolta Printer Repair, we specialize in providing fast, reliable Konica Minolta printer repair services to keep your office or business running smoothly. With years of experience and a team of certified technicians, we handle everything from paper jams to error codes, poor print quality, and network issues. We understand the importance of a well-functioning printer in your daily operations, so we offer on-site repairs, preventive maintenance, and genuine parts replacement to ensure optimal performance. Whether it's a single printer or a large fleet, we are committed to delivering affordable solutions that meet your needs.",
	},

	articles: {
		title: "Why Choose Us for Konica Minolta Printer Sales & Repair?",
		description:
			"When it comes to Konica Minolta printer sales and repairs, we stand out for our expertise, reliability, and customer satisfaction. Here’s why you should choose us:Our team consists of highly trained professionals with years of experience in Konica Minolta printer repair and maintenance. We ensure accurate diagnostics and lasting solutions.",
	},

	projects: [
		{
			title: "paper jams Error",
			description:
				"occurs when the paper fails to feed properly through the printer, causing it to get stuck in the printer mechanism. This can interrupt your printing process and, if unresolved, may cause further issues with the printer's performance.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Location",
			link: "https://g.co/kgs/iTjXAYY",
		},

		{
			title: "poor print quality",
			description:
				"refers to printouts that do not meet the expected standards of clarity, sharpness, or color accuracy. It can be caused by various factors, both technical and physical.",
			logo: "",
			linkText: "Location",
			link: "https://g.co/kgs/iTjXAYY",
		},

		{
			title: "Printer Sell",
			description:
				"Looking for a reliable printer? We offer top-brand printers for home, office, and business needs. Choose from laser, inkjet, multifunction, and high-speed printers at the best prices..",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "Location",
			link: "https://g.co/kgs/iTjXAYY",
		},

		{
			title: "Printer Repair",
			description:
				"We provide expert printer repair services for all konica minolta printers.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Location",
			link: "https://g.co/kgs/iTjXAYY",
		},

		{
			title: "Printer Spare Parts Store",
			description:
				"We offer a wide range of genuine printer spare parts to keep your machines running smoothly.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Location",
			link: "https://g.co/kgs/iTjXAYY",
		},
	],
};

export default INFO;
